module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Regular.11a0abe4.woff";